import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { campaignService } from '@/services/campaignService';
import { CampaignRequest, LeadImportRequest } from '@/types/api';
import { toast } from 'sonner';

export const useCampaigns = () => {
  return useQuery({
    queryKey: ['campaigns'],
    queryFn: campaignService.getCampaigns,
  });
};

export const useCampaign = (id: string) => {
  return useQuery({
    queryKey: ['campaign', id],
    queryFn: () => campaignService.getCampaign(id),
    enabled: !!id,
  });
};

export const useCreateCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (campaign: CampaignRequest) => campaignService.createCampaign(campaign),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      toast.success('Campanha criada com sucesso!');
    },
    onError: () => {
      toast.error('Erro ao criar campanha');
    },
  });
};

export const useUpdateCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, campaign }: { id: string; campaign: CampaignRequest }) =>
      campaignService.updateCampaign(id, campaign),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      toast.success('Campanha atualizada com sucesso!');
    },
    onError: () => {
      toast.error('Erro ao atualizar campanha');
    },
  });
};

export const useDeleteCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => campaignService.deleteCampaign(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      toast.success('Campanha excluída com sucesso!');
    },
    onError: () => {
      toast.error('Erro ao excluir campanha');
    },
  });
};

export const useSendCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => campaignService.sendCampaign(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      toast.success('Campanha enviada com sucesso!');
    },
    onError: () => {
      toast.error('Erro ao enviar campanha');
    },
  });
};

export const useImportLeads = () => {
  return useMutation({
    mutationFn: (importData: LeadImportRequest) => campaignService.importLeads(importData),
    onSuccess: (data) => {
      toast.success(`${data.imported} leads importados com sucesso!`);
    },
    onError: () => {
      toast.error('Erro ao importar leads');
    },
  });
};